import React, { useEffect, useState } from 'react';
import {
  Spin,
  Space,
  Row,
  Col,
  Button,
  Card,
  Tooltip,
  Table,
  notification,
  Input,
  Modal
} from 'antd';
import { history } from '../../redux/store';
import axios from 'axios';
import moment from 'moment';
import _ from 'underscore';
import setting from '../../config/setting';
import { PlusCircleTwoTone } from '@ant-design/icons';
import LoadingOverlay from 'react-loading-overlay';
import styled, { css } from 'styled-components';

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;

const DriversQualification = (props) => {
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const [driverResponse, setDriverResponse] = useState([]);
  const [driverAll, setDriverAll] = useState([]);
  const [change, setChange] = useState(false);
  const [imageUrls, setImageUrls] = useState('');
  const [searchFieldVal, searchField] = useState('');
  const [driverEvent, setDriverEvent] = useState([]);
  const [driverAllLength, setDriverAllLength] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  function download(e, attachment) {
    setLoader(true);
    setIsLoaderActive(true);
    axios
      .post(setting.serverUrl + '/api/downloadVaccineCertificate_emp', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          // pass: localStorage.getItem('myPass'),
          attachment_detail: [attachment[0][0]]
        }
      })
      .then((response) => {
        setIsLoaderActive(false);
        setLoader(false);
        setChange(false);
        setIsModalVisible(true);
        if (response.data && response.data.length > 0) {
          setImageUrls(response.data[0].url);
          //setImageUrls(response.data);
        }
      });
  }
  const handleCancel = () => {
    setIsModalVisible(false);
    setImageUrls('');
  };

  function getData() {
    let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));

    axios
      .post(setting.serverUrl + '/api/getEmployeeDriverQualification', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          // pass: localStorage.getItem('myPass'),
          customerId: employeeData ? employeeData.company[0] : '',
          employeeId: employeeData ? employeeData.id : ''
        }
      })
      .then((response) => {
        setChange(!change);
        if (response && response.status == 200) {
          setDriverResponse(response.data);
          setChange(!change);
          let total = response.data;
          setDriverAll(total);
          setDriverAllLength(response.data.length);
          setDriverEvent(response.data);
        } else {
          notification['error']({
            message: 'Error',
            description: 'There is some technical issue. Please try again later.'
          });
        }
      });
  }

  const columns = [
    {
      key: 'cert_type',
      dataIndex: 'cert_type',
      title: ' Certificates',
      sorter: (a, b) => a.cert_type.length - b.cert_type.length,

      render: (cert_type) => (
        <span className='nowrap'>
          <strong>{cert_type}</strong>
        </span>
      )
    },
    {
      key: 'cert_exp',
      dataIndex: 'cert_exp',
      title: 'Certificates Expiration',
      sorter: (a, b) => moment(a.cert_exp).unix() - moment(b.cert_exp).unix(),

      render: (cert_exp) => (
        <span className='nowrap'>
          <strong>{cert_exp ? moment(cert_exp).format('MM/DD/YYYY') : ''}</strong>
        </span>
      )
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: 'Status',
      //sorter: (a, b) =>(a.status.length-b.status.length),

      render: (status) => (
        <span className='nowrap'>
        {status === 'Incomplete' ? (
                      <b style={{ color: '#ffa618' }}>{status}</b>
                    ) : status === 'Exempted' ? (
                      <b style={{ color: '#6c6' }}>Exempt</b>
                    ) : status === 'Expired' ? (
                      <b style={{ color: '#f55' }}>{status}</b>
                    ) : status === 'Completed' ? (
                      <b style={{ color: '#f62' }}>Active</b>
                    ) : (
                      <b>{status}</b>
                    )}
        </span>
      )
    },

    {
      key: 'attachment_id',
      dataIndex: 'attachment_id',
      title: 'Documents',
      render: (attachment_id) => (
        <span className='nowrap'>
          {attachment_id && attachment_id.length > 0 ? (
            <button className='doclink' onClick={(e) => download(e, [attachment_id])}>
              Preview
            </button>
          ) : (
            ''
          )}
        </span>
      )
    }
  ];

  function addDriverQualification() {
    history.push({ pathname: `/vertical/addDriverQualification`, state: {} });
  }

  return (
    <div style={{ padding: 30 }}>
      <div>
        <Button
          size='small'
          style={{ backgroundColor: 'rgb(61 88 106)', color: 'white', marginTop: 0, padding: 10 }}
          onClick={() =>
            history.push({ pathname: `/vertical/driversQualificationFront`, state: {} })
          }
        >
          Go to Driver Qualifications
        </Button>
      </div>
      <Row>
        <Col span={7}>
          <h3 style={{ padding: 10, textAlign: 'left' }}>Driver History</h3>
        </Col>
        <Col span={1}>
          <Tooltip placement='top' title='Add driver certificates'>
            <PlusCircleTwoTone
              style={{ fontSize: 25, marginTop: 40, cursor: 'pointer' }}
              onClick={addDriverQualification}
            />
          </Tooltip>
        </Col>
        <Col span={8}></Col>
        <Col span={8}>
          <Input
            style={{ backgroundColor: 'white', marginTop: 30 }}
            placeholder='Type to search...'
            suffix={<span className='icofont icofont-search' />}
            value={searchFieldVal}
            onChange={(e) => {
              searchField(e.target.value);
              if (e.target.value.length > 0) {
                let datArr = driverEvent.filter(
                  (val) =>
                    (val.cert_type &&
                      val.cert_type.toLowerCase().includes(e.target.value.toLowerCase())) ||
                    (val.status && val.status.toLowerCase().includes(e.target.value.toLowerCase()))
                );
                setDriverResponse(datArr);
              } else {
                setDriverResponse(driverEvent);
              }
            }}
          />
        </Col>
      </Row>

      {driverResponse && driverResponse.length > 0 ? (
        <div>
          <Card>
            <div className='row'>
              <div className='col-12 col-md-12 col-xl-12'>
                <Table dataSource={driverResponse} columns={columns} />
              </div>
            </div>
          </Card>
        </div>
      ) : change ? (
        <Row>
          <Col span={10}></Col>
          <Col span={8}>
            <Space size='large' style={{ marginTop: 30, color: 'red' }}>
              <p style={{ fontSize: 18, fontWeight: 700, padding: 20, color: 'red' }}>
                No Record Found!
              </p>
            </Space>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col span={10}></Col>
          <Col span={8}>
            <Space size='large' style={{ marginTop: 30 }}>
              <Spin size='large' />
            </Space>
          </Col>
        </Row>
      )}
      <Modal
        width={1000}
        title='Driver Documents '
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        {loader && (
          <Space size='middle' style={{ marginLeft: 200 }}>
            <Spin size='large' style={{ height: 100, width: 100 }} />
          </Space>
        )}

        {!loader && imageUrls && (
          <p>
            <embed src={imageUrls} width='800px' height='2100px' />
          </p>
        )}
      </Modal>
      <DarkBackground disappear={isLoaderActive}>
        <LoadingOverlay active={true} spinner text='Loading...'></LoadingOverlay>
      </DarkBackground>
    </div>
  );
};

export default DriversQualification;
